import React, { ReactElement, useContext, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  DBT_MINOR_ERROR_TYPE,
  REGISTRATION_EVENTS,
  REGISTRATION_PROPERTIES,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'

import { AppContext } from '../../../context'
import { InlineErrorBanner } from '../../../molecules/inlineErrorBanner/InlineErrorBanner'
import { UICoreWidgetProps } from '../../../organisms/formBody/types'

/**
 * Error banner displayed when a DBT user enters a date of birth indicating they are under 18.
 * This is a blocking error - users cannot proceed with registration.
 * Implemented as a widget to be used in RJSF forms.
 */
export const DbtUnderageErrorBanner = (props: UICoreWidgetProps): ReactElement => {
  const { trackEvent } = useContext(AppContext)
  const show = props.schema?.show

  const hasFiredRef = useRef(false)

  // Only fire event once when banner is displayed
  useEffect(() => {
    if (show && !hasFiredRef.current) {
      hasFiredRef.current = true
      trackEvent?.(REGISTRATION_EVENTS.VIEW_DBT_MINOR_ERROR_BANNER, {
        [REGISTRATION_PROPERTIES.DBT_MINOR_ERROR]: DBT_MINOR_ERROR_TYPE.SELF_MINOR,
      })
    } else if (!show) {
      hasFiredRef.current = false
    }
  }, [show, trackEvent])

  return (
    <InlineErrorBanner
      text={
        <FormattedMessage
          defaultMessage='Accounts can only be made for adults over the age of 18+.'
          description='Error state if user indicates that they are under 18 years old when registering for DBT'
        />
      }
      testId='DbtUnderageErrorBanner'
    />
  )
}
